import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioComponent } from './radio.component';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  declarations: [RadioComponent],
  imports: [CommonModule, MatRadioModule, MatFormFieldModule, ReactiveFormsModule, FormsModule],
  providers: [],
  exports: [RadioComponent],
})
export class RadioModule {}
